import { useNavigate } from "react-router-dom";

const CATEGORIES = [
  { ic: "🚢", title: "Marine & River Logistics", desc: "Barges, tugs, landing craft, coastal and river transport supporting module and equipment movement." },
  { ic: "🏗️", title: "Heavy Lift & Cranes", desc: "Crane mobilisation, tower lift, SPMT and module handling in support of the Korean logistics chain." },
  { ic: "🧱", title: "Construction & Fabrication", desc: "Civil works, structural fabrication and site construction support for the upstream CPF and well pad scope." },
  { ic: "📐", title: "Engineering Services", desc: "Design, survey, marine and technical engineering support services." },
  { ic: "🏕️", title: "Camp, Catering & Accommodation", desc: "Workforce accommodation, camp management and catering services for project personnel." },
  { ic: "📦", title: "Equipment & General Supply", desc: "Equipment supply, rental and other project cargo and materials sourcing." },
];

export default function OpportunitiesPage() {
  const navigate = useNavigate();
  return (
    <>
      <div className="pg-hdr">
        <h1>Business Opportunities</h1>
        <p>How Korean companies can engage with the Papua LNG Project's subcontracting chain.</p>
      </div>

      <section className="sec">
        <div className="container">
          <div className="sec-hdr">
            <div className="eyebrow">How It Works</div>
            <h2>From EPC award to subcontract</h2>
            <p>
              Daewoo E&amp;C holds the upstream EPC package and appoints Tier 1
              contractors — including the Project Carrier logistics
              chain — for major scopes of work. Those Tier 1 contractors, in turn,
              engage a wider network of specialist subcontractors and suppliers.
              Korean companies can pursue opportunities at either level, depending
              on scale and capability.
            </p>
          </div>

          <div className="grid3">
            {CATEGORIES.map(c => (
              <div key={c.title} className="card">
                <div className="card-body">
                  <div className="card-ic">{c.ic}</div>
                  <h3>{c.title}</h3>
                  <p>{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sec sec-alt">
        <div className="container">
          <div className="grid2">
            <div className="info-card">
              <h3>🏢 Ready to submit your company?</h3>
              <p>
                If your company has a specific capability relevant to the upstream
                construction or logistics scope, submit your company profile,
                registration and capability documents through the Subcontract
                Submission form. This goes to the portal's review team, who route
                relevant submissions into the Korean logistics chain and Daewoo E&amp;C's
                subcontracting process.
              </p>
              <div style={{ marginTop: "1.25rem" }}>
                <button className="btn-g" onClick={() => navigate("/apply/company")}>Submit Company Profile →</button>
              </div>
            </div>
            <div className="info-card">
              <h3>🌏 Interested in other PNG projects?</h3>
              <p>
                Papua New Guinea has a broader pipeline of resource, infrastructure
                and energy projects beyond Papua LNG. If your company's interest is
                wider than this project, register your general business interest and
                we'll keep you informed of relevant opportunities.
              </p>
              <div style={{ marginTop: "1.25rem" }}>
                <button className="btn-b" onClick={() => navigate("/apply/general")}>Register General Interest →</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
